import { render, staticRenderFns } from "./DepositCoins.vue?vue&type=template&id=5b5ab45e&scoped=true&"
import script from "./DepositCoins.vue?vue&type=script&lang=js&"
export * from "./DepositCoins.vue?vue&type=script&lang=js&"
import style0 from "./DepositCoins.vue?vue&type=style&index=0&id=5b5ab45e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ab45e",
  null
  
)

export default component.exports